import { DiscountType } from '@types';
import { SiteId } from 'wly-ecommerce-common';

export const GRAPHQL_URI = process.env.REACT_APP_VIAX_GRAPHQL_URI;
export const SITE_CONFIG_API_URL = process.env.REACT_APP_SITE_CONFIG_API_URL as string;
export const DEFAULT_LOCALE = 'en-us';

export const DEFAULT_SITE_CODE = 'WIL';

export const CART_CHECKOUT_BASE_URL = process.env.REACT_APP_CART_CHECKOUT_BASE_URL as string;
// #start shared-global header/footer
export const AEM_RESOURCE_BASE_URL = process.env.REACT_APP_AEM_RESOURCE_BASE_URL as string;
// eslint-disable-next-line max-len
if (!process.env.REACT_APP_SITE_CONFIG_API_URL) {
  throw new Error('Environment variable REACT_APP_SITE_CONFIG_API_URL is not defined.');
}
export const AEM_HEADER_HEIGHT = 80;
export const DEFAULT_IMAGE = `${AEM_RESOURCE_BASE_URL}/storefront-ui-assets/wiley_logo2.png`;
// #end shared-global header/footer

export const LOCALES_MAP = {
  enAU: 'en-au',
  enBE: 'en-be',
  enBR: 'en-br',
  enCA: 'en-ca',
  enCN: 'en-cn',
  enDK: 'en-dk',
  enFR: 'en-fr',
  enGB: 'en-gb',
  enDE: 'en-de',
  enHK: 'en-hk',
  enIN: 'en-in',
  enIE: 'en-ie',
  enIT: 'en-it',
  enJP: 'en-jp',
  enMX: 'en-mx',
  enNL: 'en-nl',
  enNZ: 'en-nz',
  enNO: 'en-no',
  enSG: 'en-sg',
  enKR: 'en-kr',
  enES: 'en-es',
  enSE: 'en-se',
  enCH: 'en-ch',
  enAE: 'en-ae',
  enUS: 'en-us',
  deDE: 'de-de',
};
export const SCREEN_SIZE = {
  MOBILE: 790,
};
export const SITE_ID_URL_PARAM_KEY = 'site-id';
export const SERVER_ERROR = 'SERVER_ERROR';
export const DEFAULT_PRICE_MODEL = 'WILEYCOM';
export const CURRENCY_SIGNS: Record<string, string> = {
  USD: '$',
  GBP: '£',
  EUR: '€',
  AUD: 'AUD $',
  CAD: 'CAD $',
};

export const CART_PATH = '/cart';
export const CHECKOUT_PATH = '/checkout';
export const REGISTER_REDIRECT_PATH = '/register';

export const ALM_COOKIE_KEY = 'ALM-token';
export const ECOM_COOKIE_KEY = 'wiley-b2c-auth-token';

export const BUNDLE_DISCOUNT_TITLE = 'BUNDLE PRICE';
export const SITEWIDE_DISCOUNT_TITLE = 'SALE';
export const FREETRIAL_TITLE = 'FREE TRIAL';
export const DISCOUNTS: Record<string, string> = {
  [DiscountType.ADD_DISCOUNT]: BUNDLE_DISCOUNT_TITLE,
  [DiscountType.SITEWIDE_PRODUCT_DISCOUNT]: SITEWIDE_DISCOUNT_TITLE,
  [DiscountType.SITEWIDE_SITE_ID_DISCOUNT]: SITEWIDE_DISCOUNT_TITLE,
  [DiscountType.FREETRIAL]: FREETRIAL_TITLE,
};

export const WILEYCOM_HOST_URL = process.env
  .REACT_APP_WILEYCOM_HOST_URL as string;
export const VET_HOST_URL = process.env.REACT_APP_VET_HOST_URL as string;
export const AGS_HOST_URL = process.env.REACT_APP_AGS_HOST_URL as string;
export const SPECTRABASE_HOST_URL = process.env.REACT_APP_SPECTRABASE_HOST_URL as string;
export const AIGATEWAY_HOST_URL = process.env.REACT_APP_AIGATEWAY_HOST_URL as string;

export const CONNECT_AUTH_URL = process.env.REACT_APP_CONNECT_AUTH_URL as string;
export const CONNECT_ACCESS_TOKEN_KEY = 'CONNECT_access_token';
export const CONNECT_ID_TOKEN_KEY = 'CONNECT_id_token';

export const PHYSICAL_QTY_MAX_FOR_B2C = 10;
export const PHYSICAL_QTY_MAX_FOR_B2B = 100;

export const DEFAULT_SITE_ID = SiteId.WILEYCOM;

export const VALID_LOCALES = [
  'en-us',
  'en-au',
  'en-be',
  'en-br',
  'en-ca',
  'en-cn',
  'en-dk',
  'en-fr',
  'en-gb',
  'en-de',
  'de-de',
  'en-hk',
  'en-in',
  'en-ie',
  'en-it',
  'en-jp',
  'en-mx',
  'en-nl',
  'en-nz',
  'en-no',
  'en-sg',
  'en-kr',
  'en-es',
  'en-se',
  'en-ch',
  'de-ch',
  'en-ae',
];
